import _ from "lodash";

export const convertLivestockToLote = (livestock) => {
  if (!livestock || !livestock.farmId || !livestock.pastures) return [];

  const { farmId, pastures } = livestock;
  return _.flatMap(pastures, (pasture) =>
    pasture.livestocks.map((livestock) => ({
      IdEstadoLote: livestock.id,
      IdLote: livestock.id,
      IdCategoriaAnimal: livestock.animalCategoryId,
      IdPasto: livestock.pastureId,
      IdFazenda: farmId,
      Quantidade: livestock.quantity,
      IdObjetivo: findLivestockGoalId(livestock),
      IdPesoVisual: findLivestockWeightId(livestock, "VISUAL"),
      PesoVisual: findLivestockWeight(livestock, "VISUAL"),
      IdPesoMedido: findLivestockWeightId(livestock, "PESADO"),
      PesoMedido: findLivestockWeight(livestock, "PESADO"),
      IdPesoProjetado: findLivestockWeightId(livestock, "PROJETADO"),
      PesoProjetado: findLivestockWeight(livestock, "PROJETADO"),
      IdPesoObjetivo: findLivestockWeightId(livestock, "OBJETIVO"),
      PesoObjetivo: findLivestockWeight(livestock, "OBJETIVO"),
      IdPesoSaida: findLivestockWeightId(livestock, "SAIDA"),
      PesoSaida: findLivestockWeight(livestock, "SAIDA"),
      DataPesagem: findLivestockWeightDate(livestock, "PESADO"),
      DataPesagemVisual: findLivestockWeightDate(livestock, "VISUAL"),
      DataObjetivo: findLivestockWeightDate(livestock, "OBJETIVO"),
      DataOperacao: livestock.operationDate,
      DataValidade: livestock.endDate,
      Excluido: !!livestock.deletedAt,
      DataExclusao: livestock.deletedAt,
      DataCriacao: livestock.createdAt,
      UsuarioCriacao: livestock.creationUser,
    }))
  );
};

const findLivestockWeight = (livestock, weightType) => {
  const weight = livestock.weights.find(
    (weight) => weight.weightType === weightType
  );
  return weight ? weight.weight : weight;
};

const findLivestockWeightDate = (livestock, weightType) => {
  const weight = livestock.weights.find(
    (weight) => weight.weightType === weightType
  );
  return weight ? weight.operationDate : weight;
};

const findLivestockWeightId = (livestock, weightType) => {
  const weight = livestock.weights.find(
    (weight) => weight.weightType === weightType
  );
  return weight ? weight.id : weight;
};

export const validateLivestockResponse = (response, onSucessCallback) => {
  if (!response || !response.data || !response.data.data) {
    return {
      data: [],
    };
  }
  return onSucessCallback(response);
};

const findLivestockGoalId = (livestock = {}) => {
  const { goal } = livestock;
  return goal ? goal.id : null;
};
